import { render, staticRenderFns } from "./lateness-dashboard.vue?vue&type=template&id=4248ff5a&scoped=true&"
import script from "./lateness-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./lateness-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./lateness-dashboard.scss?vue&type=style&index=0&id=4248ff5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4248ff5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4248ff5a')) {
      api.createRecord('4248ff5a', component.options)
    } else {
      api.reload('4248ff5a', component.options)
    }
    module.hot.accept("./lateness-dashboard.vue?vue&type=template&id=4248ff5a&scoped=true&", function () {
      api.rerender('4248ff5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/milk-run/lateness-dashboard/lateness-dashboard.vue"
export default component.exports